import { render, staticRenderFns } from "./dingping.vue?vue&type=template&id=5f93e114&scoped=true&"
import script from "./dingping.vue?vue&type=script&lang=js&"
export * from "./dingping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f93e114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/thScoreShop/thScoreAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f93e114')) {
      api.createRecord('5f93e114', component.options)
    } else {
      api.reload('5f93e114', component.options)
    }
    module.hot.accept("./dingping.vue?vue&type=template&id=5f93e114&scoped=true&", function () {
      api.rerender('5f93e114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/systemCreator/systemConfig/bonusConfig/bounsCond/dingping.vue"
export default component.exports